<div class="scrollable-section">
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
      <mat-tab-group (selectedTabChange)="onSelectedTabChange()" style="overflow-y: auto;">
        <mat-tab label="Centros">
          <dx-data-grid #gridCentros [dataSource]="workCenters" [allowColumnResizing]="true" [paging]="{ pageSize: 6 }"
            [pager]="{showPageSizeSelector: false,showNavigationButtons: true,visible: true}"
            [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)"
            (onToolbarPreparing)="onToolbarPreparing($event)">
            <!-- Definición de las columnas -->

            <dxi-column dataField="name" caption="Centro" alignment="center"></dxi-column>
            <dxi-column dataField="address" caption="Localización" alignment="center"></dxi-column>
            <dxi-column dataField="enabled" caption="Habilitado" alignment="center" [visible]="false"
              [sortOrder]="'desc'"></dxi-column>


            <!-- Templates -->
            <ng-container>
              <dxi-column dataField="attendanceType1" caption="Acciones" [allowFiltering]="false" [allowSorting]="false"
                alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
              <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                <button rel="tooltip" type="button" class="btn btn-success btn-action"
                  (click)="onClickEditCenter(data.data)">
                  <i class="material-icons">edit</i>
                </button>
                <button rel="tooltip" type="button" class="btn btn-action"
                  [ngClass]="data.data.enabled ? 'btn-primary' : 'btn-default'"
                  (click)="onClickDisableWorkCenter(data)">
                  <ng-container *ngIf="data.data.enabled; else disabledIcon">
                    <i class="material-icons">toggle_on</i>
                  </ng-container>
                  <ng-template #disabledIcon>
                    <i class="material-icons">toggle_off</i>
                  </ng-template>
                </button>
              </ng-container>
            </ng-container>
            <div *dxTemplate="let data of 'addNew'">
              <button class="btn btn-primary btn-sm btn-add" [disabled]="!enableNew" (click)="onClickAddWorkCenter()">
                <i class="material-icons">add</i>
                <span class="d-none d-sm-inline-block">Nuevo</span>
              </button>
            </div>
          </dx-data-grid>
        </mat-tab>
        <mat-tab label="Tipos de marcaje">
          <dx-data-grid #gridTipos [dataSource]="attendanceTypes" [allowColumnResizing]="true"
            [paging]="{ pageSize: 6 }" [pager]="{showPageSizeSelector: false,showNavigationButtons: true,visible: true}"
            [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)"
            (onToolbarPreparing)="onToolbarPreparing($event)">
            <!-- Definición de las columnas -->

            <dxi-column dataField="name" caption="Nombre" alignment="center"></dxi-column>
            <dxi-column dataField="entry" caption="Tipo" alignment="center"
              [calculateCellValue]="calculateEntryValue"></dxi-column>
            <dxi-column dataField="imputable" caption="Suma jornada" alignment="center"
              [calculateCellValue]="calculateEntryValueYesNo">
            </dxi-column>
            <dxi-column dataField="enabled" caption="Habilitado" alignment="center" [visible]="false"
              [sortOrder]="'desc'"></dxi-column>


            <!-- Templates -->
            <ng-container>
              <dxi-column dataField="attendanceType1" caption="Acciones" [allowFiltering]="false" [allowSorting]="false"
                alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
              <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                <button rel="tooltip" type="button" class="btn btn-success btn-action"
                  (click)="onClickEditType(data.data)">
                  <i class="material-icons">edit</i>
                </button>
                <button rel="tooltip" type="button" class="btn btn-action"
                  [ngClass]="data.data.enabled ? 'btn-primary' : 'btn-default'"
                  (click)="onClickDisableAttendanceType(data)">
                  <ng-container *ngIf="data.data.enabled; else disabledIcon">
                    <i class="material-icons">toggle_on</i>
                  </ng-container>
                  <ng-template #disabledIcon>
                    <i class="material-icons">toggle_off</i>
                  </ng-template>
                </button>
              </ng-container>
            </ng-container>
            <div *dxTemplate="let data of 'addNew'">
              <button class="btn btn-primary btn-sm btn-add" (click)="onClickAddAttendanceType()">
                <i class="material-icons">add</i>
                <span class="d-none d-sm-inline-block">Nuevo</span>
              </button>
            </div>
          </dx-data-grid>
        </mat-tab>

      </mat-tab-group>
    </app-generic-panel>

  </div>




</div>